/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const moduleDeps = [require('data/util').name, 'ngFileUpload'];

const factory = function (Model, CategorizerApi, Relation) {
  let CategorizerRule;
  return (CategorizerRule = (function () {
    CategorizerRule = class CategorizerRule extends Model {
      static initClass() {
        this.prototype.$apiService = CategorizerApi;

        this.prototype.$ledger = Relation('Ledger', 'ledgerId');

        this.prototype.$sourceLedger = Relation('Ledger', 'sourceLedgerAccountId');

        this.prototype.$idSerializers = ['clientId'];

        this.prototype.id = null;
        this.prototype.clientId = 0;
      }

      $url() {
        return `clientrules/${this.id}`;
      }

      $postUrl() {
        return 'clientrules';
      }

      $init() {}
    };
    CategorizerRule.initClass();
    return CategorizerRule;
  })());
};

module.exports = angular
  .module('bench.data.model.CategorizerRule', moduleDeps)
  .factory('CategorizerRule', factory);
